<template>
  <td class="table-title-cell" :class="status">
    <div class="title">{{ value }}</div>
    <div class="subtitle" v-if="subtitle">{{ subtitle }}</div>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";
import { DateTime } from "luxon";

export default {
  mixins: [TableCellMixin],
  computed: {
    typeKey() {
      return this.row.meta?.type;
    },
    subtitle() {
      const self = this;
      const row = this.row;
      const subtitle = row.subtitle;
      const description = row.description;
      const metaDescription = row.meta?.description;
      const summary = subtitle || description || metaDescription;

      switch (this.typeKey) {
        case "runsheet":
          return row.event
            ? `${row.event.title} • ${self.$sdk.date.readableEventDate(row.event)}`
            : "";
          break;
        case "venue":
          const addressString = [
            row.address?.addressLine1,
            row.address?.addressLine2,
            row.address?.suburb,
            row.address?.state,
            row.address?.postalCode,
            row.address?.country,
          ]
            .filter(Boolean)
            .join(" ");

          return addressString;
          break;
        case "event":
          {
            const startDate = row.startDate;
            const endDate = row.endDate;

            if (self.$sdk.date) {
              if (summary) {
                return `${summary} • ${self.$sdk.date.readableEventDate(row)}`;
              } else {
                return `${self.$sdk.date.readableEventDate(row)}`;
              }
            }
          }
          break;
      }

      return summary;
    },
  },
};
</script>
<style scoped lang="scss">
td {
  line-height: 1.4em !important;
}

.title {
  font-weight: 500;
  font-size: 1.1em;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.subtitle {
  font-size: 0.9em;
  opacity: 0.5;
}
</style>
